import React from "react";
import "../mspsettingsv2.scss"
import { Dropdown } from "react-bootstrap";
import MspAccessModalToolTip from "../mspAccessModalTooltip";

const AccessItem = ({
  key = '',
  name = '',
  description = '',
  isComingSoon = false,
  dontAllowEdit = false,
  passedMarginBottom,
  options = [],
  selectedOption,
  onSelectOption = (item) => { },
}) => {
  return (
    <div className="d-flex flex-row justify-content-between  align-items-center">
      <div className="d-flex flex-row align-items-center">
        <div key={key}>{name}</div>
        <div className="w-12 tooltip-parent position-relative">
          <img alt="" src="/images/supply-chain/dark-info-icon.svg" className="mr-2 ml-2 w-100" />
          <div className="tooltip-item position-absolute" style={{ width: '150px', zIndex: 101 }}>
            <MspAccessModalToolTip data={{ Description: description }} />
          </div>
        </div>
      </div>

      {
        isComingSoon ? <div className="p-1">
          <div className="d-flex align-items-center justify-content-center rounded-full w-fit-content f-9"
            style={{ background: "#D6EDF8", color: "#008FD4", padding: "0px 6px", marginRight: "5px", marginBottom: passedMarginBottom }}
          >
            Coming Soon
          </div>
        </div> : <>
          {
            dontAllowEdit ? <div className="my-1 greyText2 mr-1">
              {selectedOption ? selectedOption.stateName : 'No Access'}
            </div> : <Dropdown className="hg-white-dropdown user-detail-dropdown">
              <Dropdown.Toggle className="custom-dropdown-toggle f-gray-imp">
                {selectedOption ? selectedOption.stateName : 'No Access'}
              </Dropdown.Toggle>
              <Dropdown.Menu renderOnMount>
                {options.map((el, index) => {
                  return (
                    <div className="p-2 pl-3 my-1 pointer f-grey"
                      key={el.stateName + index}
                      style={{ 'display': 'grid', 'grid-template-columns': '10% 90%' }}
                      onClick={(e) => {
                        onSelectOption(el);
                        e.target.closest(".hg-white-dropdown").click();
                      }}
                    >
                      <div>
                        {selectedOption?.stateName === el.stateName ? <img alt="" src="/images/settings-v2/check-icon.svg" className="mr-2" /> : <></>}
                      </div>
                      <div>
                        {el.stateName}
                        <div className="smallGreyText text-ellipsis f-darkgrey">{el.description}</div>
                      </div>

                    </div>)
                })}
              </Dropdown.Menu>
            </Dropdown>
          }
        </>
      }
    </div>
  );
};

export default AccessItem;